import { Auth0Provider } from '@auth0/auth0-react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { MapProvider, MapboxProvider } from '@ljagis/react-mapping';
import { Box } from '@material-ui/core';
import PreliminaryFloodplainModal from 'components/PreliminaryFloodplainModal';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import aerial from './assets/img/style-previews/satellite.jpeg';
import aerial2 from './assets/img/style-previews/satellite@2x.jpeg';
import streets from './assets/img/style-previews/streets.png';
import streets2 from './assets/img/style-previews/streets@2x.png';
import CameraLayer from './components/CameraLayer';
import PageNotFound from './components/PageNotFound/PageNotFound';
import MowingPublicPage from './pages/MowingPublicPage';
import ProjectsPublicPage from './pages/ProjectsPublicPage';
import SharedPublicPage from './pages/SharedPublicPage';

const {
  REACT_APP_AUTH0_CLIENT_ID: clientId = '',
  REACT_APP_AUTH0_CONNECTION: connection,
  REACT_APP_MAPBOX_ACCESS_TOKEN: accessToken,
} = process.env;

const InternalPage = () => (
  <MapProvider>
    <SharedPublicPage
      title="Internal"
      subtitle="Jefferson County DD6"
      mapStyles={[
        {
          title: 'Aerial',
          previewImage: aerial,
          previewImage2x: aerial2,
          styleUrl:
            'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/internal/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
        },
        {
          title: '2025 Aerial',
          previewImage: aerial,
          previewImage2x: aerial2,
          styleUrl:
            'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/internal/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
        },
        {
          title: 'Streets',
          previewImage: streets,
          previewImage2x: streets2,
          styleUrl:
            'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/internal/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
        },
      ]}
    />
  </MapProvider>
);

const ProtectedRoute = ({ component, ...args }: any) => (
  <Route component={withAuthenticationRequired(component)} {...args} />
);

const App = () => {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Auth0Provider
        domain="lja.auth0.com"
        clientId={clientId}
        redirectUri={window.location.href.replace(window.location.hash, '')}
        connection={connection}
      >
        <MapboxProvider accessToken={accessToken!}>
          <BrowserRouter>
            <Switch>
              <Route exact path={`${process.env.PUBLIC_URL}/row`}>
                <MapProvider>
                  <SharedPublicPage
                    title="Right of Way/Easements"
                    subtitle="Jefferson County DD6"
                    mapStyles={[
                      {
                        title: 'Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/row/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: '2025 Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/row/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: 'Streets',
                        previewImage: streets,
                        previewImage2x: streets2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/row/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                    ]}
                  />
                </MapProvider>
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/mowing`}>
                <MapProvider>
                  <MowingPublicPage
                    title="Mowing Schedule"
                    subtitle="Jefferson County DD6"
                    mapStyles={[
                      {
                        title: 'Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/mowing/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: '2025 Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/mowing/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: 'Streets',
                        previewImage: streets,
                        previewImage2x: streets2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/mowing/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                    ]}
                  />
                </MapProvider>
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/projects`}>
                <MapProvider>
                  <ProjectsPublicPage
                    title="Active Projects"
                    subtitle="Jefferson County DD6"
                    mapStyles={[
                      {
                        title: 'Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/projects/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: '2025 Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/projects/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: 'Streets',
                        previewImage: streets,
                        previewImage2x: streets2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/projects/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                    ]}
                  />
                </MapProvider>
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/flood`}>
                <MapProvider>
                  <SharedPublicPage
                    title="Flood Education Mapping Tool"
                    subtitle="Jefferson County DD6"
                    mapStyles={[
                      {
                        title: 'Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/flood/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: '2025 Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/flood/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: 'Streets',
                        previewImage: streets,
                        previewImage2x: streets2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/flood/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                    ]}
                  />
                  <PreliminaryFloodplainModal />
                </MapProvider>
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/assets`}>
                <MapProvider>
                  <CameraLayer />
                  <SharedPublicPage
                    title="DD6 Asset Management"
                    subtitle="Jefferson County DD6"
                    mapStyles={[
                      {
                        title: 'Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/assets/satellite-streets.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: '2025 Aerial',
                        previewImage: aerial,
                        previewImage2x: aerial2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/assets/eagleview.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                      {
                        title: 'Streets',
                        previewImage: streets,
                        previewImage2x: streets2,
                        styleUrl:
                          'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/assets/outdoors.json?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
                      },
                    ]}
                  />
                </MapProvider>
              </Route>
              <ProtectedRoute
                path={`${process.env.PUBLIC_URL}/internal`}
                component={InternalPage}
              />
              <Route path="*">
                <PageNotFound />
              </Route>
            </Switch>
          </BrowserRouter>
        </MapboxProvider>
      </Auth0Provider>
    </Box>
  );
};

export default App;
